import { gql } from '@apollo/client'

export const COMMENTS_PARENT_DOCUMENT_ROOT_QUERY = gql`
  query commentsParentDocumentRoot($docId: NumericID!) {
    root {
      document: documentByNumericID(artifact: "COMENTARIO", docId: $docId) {
        parentDocument {
          url
        }
      }
    }
  }
`
